import type { Components, Theme } from "@mui/material/styles";

export const MuiAlertTitle: Components<Theme>["MuiAlertTitle"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.typography.fontSizeLg,
      lineHeight: 1.5,
      fontWeight: theme.typography.fontWeightMedium,
    }),
  },
};
